const LenderDashboard = () => {
  return <div>Lender Dashboard</div>;
};

export default LenderDashboard;
